export var ExerciseState;
(function (ExerciseState) {
    ExerciseState[ExerciseState["NotViewed"] = 0] = "NotViewed";
    ExerciseState[ExerciseState["Viewed"] = 1] = "Viewed";
    ExerciseState[ExerciseState["InProgress"] = 2] = "InProgress";
    ExerciseState[ExerciseState["Solved"] = 3] = "Solved";
    ExerciseState[ExerciseState["UsedAlbertHelp"] = 4] = "UsedAlbertHelp";
})(ExerciseState || (ExerciseState = {}));
//# sourceMappingURL=Exercise.js.map